export const publicOfferQueryKeys = {
  all: ['public-offer'] as const,
  byIds: (ids: Array<string>, region: string, brand: App.Tenant['brand']) =>
    [...publicOfferQueryKeys.all, 'by-ids', region, brand, ids] as const,
  propertyNames: (ids: Array<string>, region: string, brand: App.Tenant['brand'], hintOfferIds: Array<string> = []) =>
    [...publicOfferQueryKeys.all, 'property-names', region, brand, ids, hintOfferIds] as const,
};
